/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, width: NonNullable<unknown>, height: NonNullable<unknown> }} Image_Export_Summary_Line_OneInputs */



/**
* | output |
* | --- |
* | "{count} images ({width}x{height}) + BDN XML + FCP XML" |
*
* @param {Image_Export_Summary_Line_OneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_line_one = /** @type {((inputs: Image_Export_Summary_Line_OneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_Line_OneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} images (${i?.width}x${i?.height}) + XML BDN + XML FCP`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Bilder (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} immagini (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Изображения ${i?.count} (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Imágenes ${i?.count} (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 图像（${i?.width}x${i?.height}）+ BDN XML + FCP XML`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 画像 (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} छवियाँ (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Imagens ${i?.count} (${i?.width}x${i?.height}) + XML BDN + XML FCP`)
	return /** @type {LocalizedString} */ (`${i?.count} images (${i?.width}x${i?.height}) + BDN XML + FCP XML`)
});